var $ = require('jquery');
var auth = require('../auth');

$.fn.ycgameTmplRender = function (globalOptions) {
    this.each(function () {
        var $self = $(this);
        $self.trigger('tmpl-rollback');

        var options = $.extend({
            template: $self.next('script[type="text/x-template"]').size() ? $self.next('script[type="text/x-template"]') : null
        }, globalOptions);

        var tmpl = options.template.html();
        var username = auth.member.username;
        tmpl = tmpl.replace('${username}', username);
        $self.hide();
        var $tmpl = $(tmpl);
        options.template.after($tmpl);

        $self.data('tmpl', $tmpl).one('tmpl-rollback', function () {
            $self.show();
            $tmpl.remove();
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./components/tmpl-renderer.js
// module id = 9
// module chunks = 0